// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"MyDropzone_dropzone__28XJd"};